export const FUEL_CONSUMPTION_FORM_INPUTS = [
	{
		label: "MDO",
		controlName: "MDO",
		required: false,
	},
	{
		label: "MGO",
		controlName: "MGO",
		required: false,
	},
	{
		label: "LFO",
		controlName: "LFO",
		required: false,
	},
	{
		label: "HFO",
		controlName: "HFO",
		required: false,
	},
	{
		label: "LPG Propane",
		controlName: "LPGPropane",
		required: false,
	},
	{
		label: "LPG Butane",
		controlName: "LPGButane",
		required: false,
	},
	{
		label: "LNG",
		controlName: "LNG",
		required: false,
	},
	{
		label: "Methanol",
		controlName: "methanol",
		required: false,
	},
	{
		label: "Ethanol",
		controlName: "ethanol",
		required: false,
	},
	{
		label: "Other Fuel 1",
		controlName: "otherFuel1",
		required: false,
	},
	{
		label: "Other Fuel 2",
		controlName: "otherFuel2",
		required: false,
	},
	{
		label: "Other Fuel 3",
		controlName: "otherFuel3",
		required: false,
	},
	{
		label: "Dist Travelled",
		controlName: "distTravelled",
		required: true,
	},
];

export const CII_TABLE = [
	{
		Header: "Name",
		accessor: "drawingNumber",
	},
	{
		Header: "Revision",
		accessor: "revision",
	},
	{
		Header: "Status",
		headerClassName: "text-center",
		cellClassName: "d-flex justify-content-center",
		accessor: "status",
		//future scope
		// eslint-disable-next-line react/prop-types
		// Cell: ({ value }) => (
		//   <DocumentStatus published={value === "published"}>{value}</DocumentStatus>
		// )
	},
	{
		Header: "Download",
		//future scope
		// Cell: () => <FontAwesomeIcon icon={faDownload} />
	},
];
export const CII_INSTRUCTIONS = [
	"Use the search box to lookup vessels that are enrolled in your fleet.",
	"The Vessel Type and Capacity will be filled in automatically if the vessel has already been enrolled in your fleet.",
	"You can change the values if needed.",
	"If a vessel is not enrolled in your fleet, fill in the vessel details manually.",
	"Enter the total amount of each type of fuel consumed.",
	"Enter the total distance travelled.",
	`Click "Calculate" to view the CII results.`,
];

export const VESSEL_DETAILS_FORM_HEADER = "Vessel Details";
export const CII_GRAPH_HEADER = "Vessel Details";
export const PRELIMINARY_CII_RATING_HEADER = "Preliminary CII Rating";
export const FUEL_CONSUMPTIONS_HEADER = "Fuel Consumptions";
export const CAPACITY_UNIT = "DWT/GT";
export const NM_UNIT_TEXT = "NM";
export const MT_UNIT_TEXT = "MT";
export const CALCULATE_BTN_TEXT = "Calculate";
export const INSTRUCTION_TEXT = "Instructions";
